<template>
   <section class="panel" id="recruitment-status-panel">
    <div class="recruited-state">
        <div class="recruited-btns">
            <button type="button" class="button-default pendingBtn" :class="{ active: this.jobApplication.Status === 2, enabled: this.isRecruitmentStepLocked }" @click="changeStatus('pending')" @mouseover="previewStateChange('pending')" @mouseleave="refreshState"><v-icon name="hourglass-half"/></button>
            <button type="button" class="button-default recruitedBtn" :class="{ active: this.jobApplication.Status === 3, enabled: !this.isRecruitmentStepLocked }" @click="changeStatus('recruited')" @mouseover="previewStateChange('recruited')" @mouseleave="refreshState"><v-icon name="check"/></button>
            <button type="button" class="button-default notRecruitedBtn" :class="{ active: this.jobApplication.Status === 4, enabled: !this.isRecruitmentStepLocked }" @click="changeStatus('notRecruited')" @mouseover="previewStateChange('notRecruited')" @mouseleave="refreshState"><v-icon name="times"/></button>
        </div>
        <div id="recruited-label" :class="{ recruited: this.jobApplication.Status === 3, notRecruited: this.jobApplication.Status === 4 }">{{ recruitementStateLabel}}</div>
        <transition name="modal-fade">
            <ModalConfirmation v-show="isModalCloseApplicationConfirmVisible"
            @close="closeModal('closeApplication')" @confirm="updateStatus"
            :title="confirmCloseApplicationTitle"
            :width="420" :height="230" />
        </transition>
        <transition name="modal-fade">
            <ModalConfirmation v-show="isModalReopenApplicationConfirmVisible"
            @close="closeModal('reopenApplication')" @confirm="updateStatus"
            :title="confirmReopenApplicationTitle"
            :width="420" :height="230" />
        </transition>
    </div>
  </section>
</template>
<script>
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import JobApplication from '@/models/JobApplication'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'RecruitmentStatus',
  data () {
    return {
      recruitementStateLabel: '',
      currentRecruitementState: 0,
      isModalCloseApplicationConfirmVisible: false,
      isModalReopenApplicationConfirmVisible: false,
      currentChangeStatusAction: ''
    }
  },
  props: {
    jobApplication: JobApplication
  },
  components: {
    ModalConfirmation
  },
  watch: {
    'jobApplication.Status' () {
      this.changeStatusLabel(this.jobApplication.Status)
    }
  },
  computed: {
    ...mapGetters([
      'isRecruitmentStepLocked'
    ]),
    confirmCloseApplicationTitle () {
      if (this.currentChangeStatusAction === 'recruited') {
        return 'Voulez-vous vraiment recruter ce candidat ?'
      } else if (this.currentChangeStatusAction === 'notRecruited') {
        return 'Voulez-vous vraiment rejeter cette candidature ?'
      }
      return 'Voulez-vous vraiment cloturer cette candidature ?'
    },
    confirmReopenApplicationTitle () {
      return 'Voulez-vous vraiment réouvrir cette candidature ?'
    }
  },
  methods: {
    showModal (type) {
      if (type === 'closeApplication') {
        this.isModalCloseApplicationConfirmVisible = true
      } else if (type === 'reopenApplication') {
        this.isModalReopenApplicationConfirmVisible = true
      }
    },
    closeModal (type) {
      if (type === 'closeApplication') {
        this.isModalCloseApplicationConfirmVisible = false
      } else if (type === 'reopenApplication') {
        this.isModalReopenApplicationConfirmVisible = false
      }
    },
    updateStatus () {
      if (this.currentChangeStatusAction !== undefined) {
        this.$emit('updateStatus', this.currentChangeStatusAction)
        this.closeModal('closeApplication')
        this.closeModal('reopenApplication')
        this.currentChangeStatusAction = ''
      }
    },
    changeStatus (action) {
      if ((action === 'pending' && this.jobApplication.Status !== 2) || (action !== 'pending' && !this.isRecruitmentStepLocked)) {
        this.currentChangeStatusAction = action
        if (action === 'pending') {
          this.showModal('reopenApplication')
        } else {
          this.showModal('closeApplication')
        }
      }
    },
    previewStateChange (status) {
      if (status === 'pending' && this.jobApplication.Status !== 2) {
        this.recruitementStateLabel = 'Rouvrir'
      } else if (status === 'recruited' && this.jobApplication.Status !== 3 && !this.isRecruitmentStepLocked) {
        this.recruitementStateLabel = 'Recruter'
      } else if (status === 'notRecruited' && this.jobApplication.Status !== 4 && !this.isRecruitmentStepLocked) {
        this.recruitementStateLabel = 'Rejeter'
      }
    },
    changeStatusLabel (status) {
      if (status === 1) {
        this.recruitementStateLabel = 'Rouvert'
      } else if (status === 2) {
        this.recruitementStateLabel = 'Ouvert'
      } else if (status === 3) {
        this.recruitementStateLabel = 'Recruté'
      } else if (status === 4) {
        this.recruitementStateLabel = 'Non Recruté'
      }
    },
    refreshState () {
      this.changeStatusLabel(this.jobApplication.Status)
    }
  },
  mounted () {
    this.refreshState()
  }
}
</script>
